import { RootState } from "../../store";

export const selectPermission = (state: RootState) => state.permission;